import type { ReactNode } from 'react';
import { FormConfigProvider } from '@repo/ui/lib/form-config';
import { usePermissions } from '@/hooks/use-permissions';

/**
 * Configurazione dei form di `@repo/ui` per la webapp: senza `canWrite` ogni
 * `FormFooter` è in sola lettura.
 */
export function WebFormConfigProvider({ children }: { children: ReactNode }) {
  const { canWrite } = usePermissions();

  return (
    <FormConfigProvider canWrite={canWrite}>{children}</FormConfigProvider>
  );
}
